import React from 'react';

const Errors = (props) => {

	const ErrorMessages = props.errors.map((error, key) => {
		return (
			<li key={key}>{error}</li>
		);
	});

	return (
		<div className={`row error-msg ${props.className}`}>
			<ul>
				{ErrorMessages}
			</ul>
		</div>
	);

};

export default Errors;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/Errors.js